module.exports = __webpack_public_path__ + "img/logo.6c74ca21.gif";